import * as React from 'react';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import { useTheme } from '@mui/joy/styles';
import { CustomDimensions, theme } from 'styles/theme/themes';
import Box from '@mui/joy/Box';

interface HoverButtonProps {
  onClick: (any) => void;
  icon: React.ReactNode;
  text?: string;
  showBackground?: boolean;
  onHoverColor?: string;
  sx?: any;
  disabled?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
}

const HoverButton: React.FC<HoverButtonProps> = ({
  onClick,
  icon,
  text,
  showBackground,
  onHoverColor,
  sx,
  disabled,
  ref,
}) => {
  return (
    <Button
      ref={ref}
      onClick={onClick}
      variant="plain"
      disabled={disabled}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        // gap: 1,
        aspectRatio: '1',
        borderRadius: theme => CustomDimensions.cornerRadius,
        '& .MuiSvgIcon-root': {
          color: theme => theme.vars.palette.neutral[400],
          transition: 'color 0.2s ease-in-out, transform 0.2s ease-in-out',
          fontSize: CustomDimensions.iconSize,
        },
        '&:hover .MuiSvgIcon-root': {
          color: theme => theme.vars.palette.neutral[600],
          transform: 'scale(1.05)',
        },
        '&:hover': {
          backgroundColor: onHoverColor
            ? onHoverColor
            : theme => theme.vars.palette.neutral[100],
        },
        px:{
          xs: 1,
          md: 2
        },
        ...sx,
      }}
    >
      {icon}
      {text && (
        <Typography level="title-md" sx={{ whiteSpace: 'nowrap' }}>
          {text}
        </Typography>
      )}
    </Button>
  );
};

export default HoverButton;
